<template>
    <v-container fluid class="text-xs-center"> 
        <v-layout row wrap>
            <v-form>
                <v-container>
                    <div class="vrow">
                        <h4>Dati dell'animale</h4>
                        <v-text-field
                            v-model="pet.name"
                            :counter="40"
                            label="Nome"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="pet.species"
                            :counter="40"
                            label="Specie"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="pet.breed"
                            :counter="40"
                            label="Razza"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="pet.size"
                            :counter="15"
                            label="Dimensioni"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="pet.weight"
                            :counter="40"
                            label="Peso"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="pet.microchip"
                            :counter="15"
                            label="Microchip"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="pet.birthday"
                            type="date"
                            label="Compleanno"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="pet.compatibility"
                            :counter="40"
                            label="Compatibilità"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="pet.notes"
                            :counter="300"
                            label="Note"
                            required
                        ></v-text-field>
                    </div>
                    <div class="vrow">
                        <h4>Dati sanitari</h4>
                        <v-text-field
                            v-model="pet.vaccinationDate"
                            type="date"
                            label="Data vaccinazione"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="pet.antiparasiticDate"
                            type="date"
                            label="Data antiparassitario"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="pet.pathologies"
                            :counter="300"
                            label="Patologie"
                            required
                        ></v-text-field>
                    </div>
                </v-container>
            </v-form>
        </v-layout>
        <v-btn
            dark
            absolute
            bottom
            right
            fab
            color="green"
            style="bottom:20px;"
            @click.native="updatePet()"
            > <v-icon style="font-size:40px;padding-top:5px;">check</v-icon>
        </v-btn>
    </v-container>
</template>

<script>
const axios = require('axios').default;
export default {
    name: 'PetEdit',
    data: function(){
        return{
            showDeletionDialog: false,
            showDeletedToast: false,
            searchedText: "",
            pet:{
                name:null,
                species:null,
                breed:null,
                size:null,
                weight:null,
                microchip:null,
                birthday:null,
                compatibility:null,
                notes:null,
                vaccinationDate: null,
                antiparasiticDate: null,
                pathologies:null
            }
        };
    },
    mounted: function(){
        let vm = this;
        vm.getPet();
    },
    methods:{
        getPet(){
            let vm = this;
            axios({
                method: "GET",
                url: vm.$API_BASE_URL + "getPet.php?petId="+vm.$route.params.petId,
                headers: {
                    'Authentication-Token': window.localStorage.getItem("sogno_at")
                }
            })
            .then(function (response) {
                if (response.status == 200) {
                    vm.pet = response.data.resource;
                } 
                else{
                    alert("Si è verificato un errore durante il caricamento");
                }
            })
            .catch(function (error) {
                if(error.response.status==403||error.response.status==401){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert("Si è verificato un errore durante il caricamento");
                    console.error(error)
                }
            });
        },
        updatePet(){
            let vm = this;
            let finalPet = vm.pet;
            finalPet.petId = vm.$route.params.petId;
            axios({
                method: "POST",
                url: vm.$API_BASE_URL + "editPet.php",
                data: finalPet,
                headers: {
                    'Authentication-Token': window.localStorage.getItem("sogno_at")
                }
            })
            .then(function (response) {
                if (response.status == 200) {
                    vm.$router.push({name: 'pet', params:{petId:vm.$route.params.petId}});
                } 
                else{
                    alert("Si è verificato un errore durante il caricamento");
                }
            })
            .catch(function (error) {
                if(error.response.status==403||error.response.status==401){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert("Si è verificato un errore durante il caricamento");
                    console.error(error)
                }
            });
        }
    }
}
</script>
<style>
.vrow{
    display: inline-block;
    width:48%;
    padding-right:2%;
    vertical-align: top;
}
.v-form{
    width:100%;
}
h4{
    font-size: 20px;
}
</style>